import React from 'react';

// import { P } from '../P/P';
import { Section } from './Section';
import { UL } from './UL';
import { LI } from './LI';
// import { ExternalLink } from './ExternalLink';

export const LE4_4 = () => (
  <Section>

    <UL>
      <LI>
        Erweitern Sie abschließend die <b>Mind-Map</b> aus der Lerneinheit 1 um neue Begriffe, die den SuS nun noch zusätzlich einfallen.
      </LI>
    </UL>

  </Section>
);



// WEBPACK FOOTER //
// ./src/components/LE/LE4_4.js